var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sustainability',{attrs:{"sustainability-data":_vm.payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }